export default __webpack_public_path__ + "static/media/mnmCt.145a219f.png";